import QuerySection from "./QuerySection";
import { SelectFormSection } from "./SelectFormSection";
import { SetIntegrationWebhookTrigger } from "./SetIntegrationWebhookTrigger";
import { WebhookPostSection } from "./WebhookPostSection";
import { DataViewType } from "@prisma/client";
import { useFormContext } from "react-hook-form";

export function SelectDataSection(): JSX.Element {
  const { watch } = useFormContext();
  const type = watch("_workflowType");
  const dataViewType = watch("dataViewType");
  switch (type) {
    case "WEBHOOK":
      return (
        <div className="px-16">
          <WebhookPostSection />
        </div>
      );
    case "FORM":
      return (
        <div className="px-16">
          <SelectFormSection />
        </div>
      );
    case "REACTION_ADDED":
    case "NEW_MESSAGE":
      return (
        <div className="px-16">
          <SetIntegrationWebhookTrigger type={type} />
        </div>
      );
    default:
      return <QuerySection visualQueryEditor={dataViewType === DataViewType.VISUAL} />;
  }
}
